import { motion } from "framer-motion";
import { Quote } from "lucide-react";

export default function About() {
  return (
    <section
      id="ueber-uns"
      data-testid="about-section"
      className="border-t border-line bg-sand-deep py-24 lg:py-32"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-start gap-16 px-6 lg:grid-cols-12 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-5"
        >
          <div className="editorial-frame">
            <img
              src="https://images.pexels.com/photos/36765718/pexels-photo-36765718.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="Persönliches Beratungsgespräch zur Auswanderung und Unternehmensgründung in Florida"
              data-testid="about-image"
              className="aspect-[4/5] w-full object-cover"
              loading="lazy"
            />
          </div>
        </motion.div>

        <div className="lg:col-span-7">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6 }}
            className="text-xs uppercase tracking-[0.3em] text-clay"
            data-testid="about-eyebrow"
          >
            Über uns
          </motion.p>

          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="mt-6 font-serif text-4xl leading-tight tracking-tight text-ink sm:text-5xl"
            data-testid="about-title"
          >
            Beratung aus{" "}
            <span className="italic text-clay">echter Erfahrung</span>
          </motion.h1>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="mt-8 space-y-6 text-base leading-relaxed text-ink-muted md:text-lg"
            data-testid="about-copy"
          >
            <p>
              Ich bin Unternehmerin – und selbst den Schritt in die USA
              gegangen. Als International Business &amp; Relocation Strategist
              begleite ich Deutsche und Schweizer bei der Gründung, beim
              Markteintritt in den USA und durch das gesamte Visumsverfahren –
              vom E-2-Visum bis zur direkten Green Card über EB-2 NIW oder
              EB-1C.
            </p>
            <p>
              Mein Fokus liegt auf U.S. Market Entry, Business Development und
              Cross-Border-Prozessen. Ihren Visumsfall betreue ich von A bis
              Z – von der Strategie über die komplette Antragstellung bis zur
              Entscheidung. Sie bekommen alles aus einer Hand, auf Deutsch.
            </p>
            <ul
              className="grid grid-cols-1 gap-px border border-line bg-line !mt-10 sm:grid-cols-3"
              data-testid="about-specializations"
            >
              {[
                "U.S. Market Entry",
                "Business Development",
                "Immigration Case Coordination",
              ].map((item) => (
                <li
                  key={item}
                  className="bg-sand px-4 py-3 text-center text-xs uppercase tracking-[0.15em] text-ink"
                >
                  {item}
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.blockquote
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.3 }}
            className="mt-12 border-l-2 border-clay pl-8"
            data-testid="about-quote"
          >
            <Quote className="mb-4 h-6 w-6 text-clay" strokeWidth={1.25} />
            <p className="font-serif text-2xl italic leading-snug tracking-tight text-ink sm:text-3xl">
              Persönliche Betreuung auf Deutsch – von der Gründung bis weit nach
              der Auswanderung.
            </p>
          </motion.blockquote>

          <motion.ul
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.4 }}
            className="mt-12 grid grid-cols-1 gap-px border border-line bg-line sm:grid-cols-3"
            data-testid="about-values"
          >
            {["Persönlich", "Auf Deutsch", "Langfristig an Ihrer Seite"].map(
              (value) => (
                <li
                  key={value}
                  className="bg-sand px-5 py-4 text-center text-xs uppercase tracking-[0.2em] text-ink"
                >
                  {value}
                </li>
              ),
            )}
          </motion.ul>
        </div>
      </div>
    </section>
  );
}
